export const LblCtrlModel = function (data) {
    if (!data) data = {};
    this.text = data.text || "";
    this.className = data.className || null;
    this.style = data.style || null;
};